import apiHelpers from './apiHelpers.js';
import { mapCrudStoreGen } from '@/helpers/utils/storeHelpers.js';
let defaultForm = {
  source: 'UPSDirect',
  country: 'US',
  chargeClassCode: '',
  chargeDescriptionCode: '',
  chargeDescription: '',
  type: 'Unknown'
};

let defaultFilters = {
  source: null,
  country: '',
  status: null,
  chargeClassCode: '',
  chargeDescriptionCode: '',
  chargeDescription: '',
  type: null
};

let genedStore = mapCrudStoreGen(defaultForm, defaultFilters, apiHelpers);

export default {
  namespaced: true,

  state: () => ({
    ...genedStore.state
  }),

  mutations: {
    ...genedStore.mutations
  },

  getters: {
    ...genedStore.getters
  },

  actions: {
    ...genedStore.actions
  },
};